import {makeAutoObservable} from "mobx";
import {MIN_LENGTH} from "../config";
import {checkIsEnglish, logEvent} from "../utils";
import {plagiarismFileRequest, plagiarismRequest, sendFileRequest, sendRequest, updateText} from "../requests";
import {normalizeAndCleanString} from "../elements/utils/utils";


export class InputStore {

    text = ''
    loadingAI = false;
    loadingPlagiarism = false;
    percents = -1;
    error = undefined;
    segments = '';
    wordsModalOpened = false;
    textId = -1;
    plagiarismData = null;
    plagiarismSegments = [];
    activeSection = 'AI';
    scannedOn = undefined;
    showPlanUpgradeTooltip = false;
    freePremiumModalOpened = false;

    plagiarism = false
    aiScan = false
    deepAiScan = false

    updated = false
    showPlagiarismGuardModal = false

    setShowPlagiarismGuardModal(show) {
        this.showPlagiarismGuardModal = show
    }


    selectPlagiarism() {
        const user = this.root.getUser()
        if (!user?.can_create_plagiarism_request && user?.free_plagiarism_attempts <= 0 && !this.plagiarism) {
            this.showPlagiarismGuardModal = true
            return;
        }
        const url = new URL(window.location.href);
        if (!this.plagiarism) {
            url.searchParams.set('plagiarism', 'true');
        } else {
            url.searchParams.delete('plagiarism');
        }
        this.setPlagiarism(!this.plagiarism);
        window.history.replaceState({}, '', url.toString());
    }

    setDeepAiScan(value) {
        this.deepAiScan = value
    }

    setUpdated(value) {
        this.updated = value
    }

    setPlagiarism(value) {
        this.plagiarism = value
    }

    setAiScan(value) {
        this.aiScan = value
    }

    constructor(root) {
        this.root = root
        makeAutoObservable(this)
        this.setText("")
    }

    setText(text) {
        this.text = text
        this.percents = -1;
        this.plagiarismData = null;
        this.plagiarismSegments = [];
        this.setSegments('');
    }

    setPercents(value) {
        this.percents = value
    }

    setSegments(segments) {
        this.segments = segments;
    }

    isCertAvailable() {
        return !this.loadingAI && this.percents !== -1
    }

    setShowPlanUpgradeTooltip(show) {
        this.showPlanUpgradeTooltip = show;
    }

    setFile(file) {
        this.file = file;
    }

    get isPlagiarismView() {
        return this.activeSection === "Plagiarism"
    }

    setWordsModalOpened(value) {
        this.wordsModalOpened = value
    }

    setActiveSection(section) {
        this.activeSection = section
    }

    setId(id) {
        this.textId = id
    }

    setPlagiarismSegments(segments) {
        this.plagiarismSegments = segments
    }

    setPlagiarismData(data) {
        this.plagiarismData = data
    }

    setLoadingPlagiarism(value) {
        this.loadingPlagiarism = value
    }

    setScannedOn(value) {
        this.scannedOn = value
    }

    setLoadingAI(value) {
        this.loadingAI = value
    }

    setError(error) {
        this.error = error
    }

    setFreePremiumModalOpened(value) {
        this.freePremiumModalOpened = value
    }

    sendPlagiarismDataToBackend(analysis_id) {
        let localText = normalizeAndCleanString(this.text);
        this.setText(localText);
        if (!localText.endsWith('.')) {
            this.setText(localText + '.');
            localText = localText + '.';
        }
        this.setLoadingPlagiarism(true);
        plagiarismRequest(localText, analysis_id).then((e) => {
            this.root.plagiarism.setOriginalText(localText);
            this.setLoadingPlagiarism(false);
            this.setPlagiarismData(e.plagiarism);
            this.setPlagiarismSegments(e.plagiarism_segments);
        })
    }

    sendDataToBackend(deep) {
        const deepAiScan = deep
        const updated = this.updated
        // TODO: refactor and remove this dependency

        const text = this.text
        const localText = normalizeAndCleanString(text);
        this.setText(localText);
        if (localText.length < MIN_LENGTH && !this.file) {
            this.setError(`Try typing more text (>${MIN_LENGTH} characters) so we can give you more accurate results`);
            return;
        }
        if (!checkIsEnglish(localText) && !this.file) {
            this.setError('Only English is supported');
            return;
        }
        logEvent(`scan_${deep ? 'deep' : 'simple'}_scan`);
        if (this.root.user.shouldShowEnrollModal()) {
            this.setFreePremiumModalOpened(true);
        }
        this.root.user.incrementEnrollCount();
        var parsedText = localText;
        parsedText = parsedText.replace(/ [\n\r]\d+\.?\d*\s*%\s*(of)?\s*AI[\n\r]/gi, '');
        this.setText(parsedText);
        if (this.aiScan || deepAiScan) {
            this.setLoadingAI(true);
            this.setPercents(-1);
            this.setError(undefined);
        }

        if (this.file && localText.length < MIN_LENGTH) {
            if (deepAiScan || this.aiScan) {
                sendFileRequest(this.file, deep, this.plagiarism).then((e) => {
                    this.root.refresh();
                    this.setId(e.id);
                    console.log(e.plagiarism, this.plagiarism, "plagiarism");
                    if (this.plagiarism) {
                        this.setPlagiarismData(e.plagiarism);
                        this.setText(e.text);
                    }
                    if (deepAiScan || this.aiScan) {
                        if (Number.isNaN(Number.parseFloat(e.answer))) {
                            console.log(e.error);
                            this.setError(e.error);
                            this.setLoadingAI(false);
                            return;
                        }
                    else {
                            this.setText(e.text);
                        }
                        this.setPercents(Number.parseFloat(e.answer) * 100);
                        if (deep) {
                            this.setSegments(e.segments);
                        } else {
                            this.setSegments('');
                        }
                        if (this.plagiarism) {
                            this.setPlagiarismSegments(e.plagiarism_segments);
                        }
                        else {
                            this.setPlagiarismSegments('');
                        }
                    }
                    this.setLoadingAI(false);
                })
            }
            if (this.plagiarism) {
                this.setLoadingPlagiarism(true);
                plagiarismFileRequest(this.file).then((e) => {
                    this.setLoadingPlagiarism(false);
                    this.setPlagiarismData(e.plagiarism);
                    this.setPlagiarismSegments(e.plagiarism_segments);
                })
            }
        } else {
            if (deepAiScan || this.aiScan) {
                sendRequest(parsedText, deep, "app").then((e) => {
                    this.root.refresh();
                    if (this.plagiarism) {
                        this.sendPlagiarismDataToBackend(e.id.toString());
                    }
                    this.setScannedOn(new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit'}));
                    this.setLoadingAI(false);
                    if (deepAiScan || this.aiScan) {
                        if (e.answer != null) {
                            this.setId(e.id);
                            if (updated) {
                                updateText(e.id.toString(), localText);
                                this.setUpdated(false);
                            }
                            this.setPercents((e.answer) * 100);
                            if (deep) {
                                this.setSegments(e.segments);
                            } else {
                                this.setSegments('');
                            }
                        } else {
                            this.setError(e.error);
                        }
                    }
                })
            }
            if (this.plagiarism && !deepAiScan && !this.aiScan) {
                this.sendPlagiarismDataToBackend();
            } else {
                this.setPlagiarismData(null);
                this.setPlagiarismSegments('');
            }

        }
    }
}
